import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-zinc-950 text-gray-300 py-12 mt-20 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <h3 className="text-red-500 text-2xl font-black tracking-tighter">CineStream</h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              Your ultimate destination for streaming movies and TV shows online for free. Enjoy high-quality content without registration.
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">Navigation</h4>
            <ul className="space-y-1.5 text-sm">
              <li><Link to="/" className="inline-block py-1.5 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/movies" className="inline-block py-1.5 hover:text-white transition-colors">Movies</Link></li>
              <li><Link to="/tv" className="inline-block py-1.5 hover:text-white transition-colors">TV Shows</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">Legal</h4>
            <ul className="space-y-1.5 text-sm">
              <li><Link to="/terms" className="inline-block py-1.5 hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="inline-block py-1.5 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/dmca" className="inline-block py-1.5 hover:text-white transition-colors">DMCA</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">Support & Company</h4>
            <ul className="space-y-1.5 text-sm">
              <li>
                <Link 
                  to="/donate" 
                  className="text-red-400 hover:text-red-300 font-bold inline-flex items-center gap-1.5 py-1.5 transition-all hover:translate-x-1"
                >
                  ❤️ Donate & Support
                </Link>
              </li>
              <li><Link to="/about" className="inline-block py-1.5 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="inline-block py-1.5 hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-white/5 text-sm text-center flex flex-col items-center space-y-2">
          <p className="text-gray-300">&copy; {new Date().getFullYear()} CineStream. All rights reserved.</p>
          <p className="text-xs text-gray-400 max-w-3xl">
            Disclaimer: This site does not store any files on its server. All contents are provided by non-affiliated third parties.
          </p>
        </div>
      </div>
    </footer>
  );
};
